<template>
    <div>

        <PageHeader title="Teams">
            <div class="actionBtns">
                <button class="default simple _icon" v-if="isUserPermitted('teams', 'manage')" @click="addItem = true">Create team<i class="fas fa-plus"></i></button>
            </div>
        </PageHeader>

        <Modal v-model="addItem" title="Create team">
            <Create v-if="addItem" @added="getItems(); hideAddModal()"/>
        </Modal>

        <Modal v-model="editItem" @close="deselect" title="Team details">
            <Edit v-if="selectedItem" :item="selectedItem" @updated="getItems"/>
        </Modal>
        
        <div class="wrapper">
            <Table class="itemTable" :cols="['Name', 'Team', 'Carriers', 'Action']">
                <div class="row" :key="key" v-for="(item, key) of items">
                    <div>{{ item.name }}</div>
                    <div>{{ item.users ? item.users.length : 0 }} members</div>
                    <div>{{ item.carriers ? item.carriers.length : 0 }} carriers</div>
                    <div><button class="default small round reverse" @click="editItemDetails(item)">View</button></div>
                </div>
            </Table>
        </div>


    </div>
</template>

<script>
import Create from '../../components/teams/Create.vue'
import Edit from '../../components/teams/Edit.vue'

    export default {
        components: {
            Create,
            Edit
        },
        data() {
            return {
                addItem: false,
                editItem: false,
                selectedItem: null,
                items: []
            }
        },
        methods: {
            hideAddModal() {
                this.addItem = false;
            },
            getItems() {
                this.$axios.get('/teams')
                .then(data => {
                    this.items = data.data;
                });
            },
            editItemDetails(item) {
                this.selectedItem = JSON.parse(JSON.stringify(item));
                this.editItem = true;
            },
            pushItem(item) {
                this.items.push(item);
            },
            deselect() {
                this.selectedItem = null;
            }
        },
        mounted() {
            this.getItems();
        }
    }
</script>


<style lang="scss">
.itemTable {
    .row {
        grid-template-columns: repeat(3, minmax(0, 1fr)) 150px !important;
    }
}
</style>

<style lang="scss" scoped>

.itemTable {
    .row {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr)) 150px !important;
        height: 50px;
        align-items: center;
        padding: 10px 20px;
        column-gap: 20px;

        &:nth-child(2n) {
            background: $bg;
        }
        &:last-child {
            border-radius: 0 0 $borderRadius $borderRadius;
        }
    }
}

.editBtn {
    border: 0;
    background: transparent;
    width: 34px;
    height: 34px;
    padding: 0;
}
</style>